<template>
    <v-app dir="ltr">

  <div dir="ltr">
    <router-view></router-view>
     <set-address-profile  v-if="shouldShowAddressPopup"
      v-model="showAddressPopup" 
      @success="onAddressSuccess" 
    />
  </div>
  </v-app>
</template>

<style lang="scss">
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~animate.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";
@import "assets/css/style.vue.rtl";
.v-application {
  background: transparent !important;
  
  .v-application--wrap {
    background: transparent !important;
    min-height: 100vh;
  }
}

</style>

<script>
import { OVERRIDE_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import { rbAxios, RobotAxios, SmsAxios } from "@/main";
import setAddressProfile from "./core/plugins/TitleRibbon/setAddressProfile.vue";
import "bootstrap";


window.$ = window.jquery = window.jQuery = require("jquery");
export default {
  name: "MetronicVue",
  components:{setAddressProfile},
  computed: {
    shouldShowAddressPopup() {
      try {
        const userInfo = localStorage.getItem("user_info");
        if (!userInfo) return false; 
        
        const parsedUser = JSON.parse(userInfo);
        return parsedUser && Number(parsedUser.id) !== 75;
      } catch (e) {
        return false;
      }
    }
  },
  mounted() {
    this.$api.defaults.headers["lang"] = this.$i18n.locale || "fa";
    document.body.className = `lang-${this.$i18n.locale}`;
    this.$api.defaults.headers[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("id_token")}`;
    rbAxios.defaults.headers["Authorization"] =
      localStorage.getItem("id_token");
    RobotAxios.defaults.headers[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("id_token")}`;
    SmsAxios.defaults.headers["Authorization"] = `Bearer ${localStorage.getItem(
      "id_token"
    )}`;
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
    this.$root.$on("open-address-popup", () => {
      this.showAddressPopup = true;
    });

  },
    data(){
    return{
      showAddressPopup: false,
    }
  },
  methods:{
     onAddressSuccess() {
      console.log("آدرس با موفقیت ثبت شد");
    }
  },

  watch: {
    "$i18n.locale"(newLocale) {
      document.body.classList.remove("lang-fa", "lang-ar", "lang-en");
      document.body.classList.add(`lang-${newLocale}`);
    },
  },
    beforeDestroy() {
    this.$root.$off("open-address-popup");
  },

};
</script>

<style></style>
